<!-- 登记信息弹窗 -->
<template>
    <el-dialog title="登记信息" :visible.sync="dialogVisible" width="700px" center :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="true">
        <el-form ref="registrationForm" :model="formData" label-width="120px" size="small">
            <el-row :gutter="5">
                <el-col :span="12">
                    <el-form-item label="病人姓名" prop="patientName">
                        <el-input v-model="formData.patientName" placeholder="请输入病人姓名" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="住院号" prop="hospNum">
                        <el-input v-model="formData.hospNum" placeholder="请输入住院号" clearable />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="5">
                <el-col :span="12">
                    <el-form-item label="手术医师" prop="surgicalDoctor">
                        <el-input v-model="formData.surgicalDoctor" placeholder="请输入手术医师" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="护士" prop="nurse">
                        <el-input v-model="formData.nurse" placeholder="请输入护士" clearable />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="5">
                <el-col :span="12">
                    <el-form-item label="消毒证明" prop="disinfectionCertificate">
                        <el-upload class="upload-demo" action="#" :http-request="(options) => customUpload(options, 'disinfectionCertificate')" :multiple="true"
                                   :before-remove="(file, fileList) => beforeRemove(file, fileList, 'disinfectionCertificate')" :before-upload="beforeUpload" :file-list="disinfectionFileList" list-type="picture"
                                   :key="'disinfection_' + uploadKey">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="植入证明" prop="implantationCertificate">
                        <el-upload class="upload-demo" action="#" :http-request="(options) => customUpload(options, 'implantationCertificate')" :multiple="true"
                                   :before-remove="(file, fileList) => beforeRemove(file, fileList, 'implantationCertificate')" :before-upload="beforeUpload" :file-list="implantationFileList" list-type="picture"
                                   :key="'implantation_' + uploadKey">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="5">
                <el-col :span="12">
                    <el-form-item label="病人档案" prop="patientFile">
                        <el-upload class="upload-demo" action="#" :http-request="(options) => customUpload(options, 'patientFile')" :multiple="true"
                                   :before-remove="(file, fileList) => beforeRemove(file, fileList, 'patientFile')" :before-upload="beforeUpload" :file-list="patientFileList" list-type="picture"
                                   :key="'patientFile_' + uploadKey">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注信息" maxlength="500" show-word-limit />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">
                确 定
            </el-button>
        </div>

    </el-dialog>
</template>

<script>
export default {
    name: 'RegistrationInfoDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        // 初始数据
        initialData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            formData: {
                disinfectionCertificate: '', // 消毒证明 (文件URL字符串，逗号分割)
                hospNum: '',                 // 住院号
                implantationCertificate: '', // 植入证明 (文件URL字符串，逗号分割)
                nurse: '',                   // 护士
                patientFile: '',             // 病人档案 (文件URL字符串，逗号分割)
                patientName: '',             // 病人姓名
                remark: '',                  // 备注
                surgicalDoctor: '',          // 手术医师
                cmId: '',                     // 客户ID
                cosumId: ''                    // 	预出库订单ID
            },
            // 文件上传相关
            disinfectionFileList: [],       // 消毒证明文件列表
            implantationFileList: [],       // 植入证明文件列表
            patientFileList: [],            // 病人档案文件列表
            uploadKey: 0,                   // 用于强制重新渲染 el-upload 组件
            imgUrl: '',                     // 图片基础URL
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            }
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.initFormData()
                this.$emit('opened')
            }
        },
        initialData: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.initFormData()
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 初始化表单数据
        initFormData() {
            // 重置表单
            this.resetForm()

            // 如果有初始数据，则填充表单
            if (this.initialData && Object.keys(this.initialData).length > 0) {
                Object.keys(this.formData).forEach(key => {
                    if (this.initialData.hasOwnProperty(key)) {
                        this.formData[key] = this.initialData[key] || ''
                    }
                })

                // 初始化文件列表
                this.initFileListsFromData()
            }
        },

        // 重置表单
        resetForm() {
            Object.keys(this.formData).forEach(key => {
                this.formData[key] = ''
            })

            // 重置文件列表
            this.disinfectionFileList = []
            this.implantationFileList = []
            this.patientFileList = []
            this.uploadKey = Date.now()

            if (this.$refs.registrationForm) {
                this.$refs.registrationForm.clearValidate()
            }
        },

        // 从数据初始化文件列表
        initFileListsFromData() {
            // 消毒证明文件列表
            if (this.formData.disinfectionCertificate) {
                this.disinfectionFileList = this.formData.disinfectionCertificate.split(',').map((url, index) => ({
                    name: `消毒证明_${index + 1}`,
                    url: this.getFileDisplayUrl(`file_${index}.pdf`, url),
                    uid: `disinfection_${index}_${Date.now()}`
                }))
            }

            // 植入证明文件列表
            if (this.formData.implantationCertificate) {
                this.implantationFileList = this.formData.implantationCertificate.split(',').map((url, index) => ({
                    name: `植入证明_${index + 1}`,
                    url: this.getFileDisplayUrl(`file_${index}.pdf`, url),
                    uid: `implantation_${index}_${Date.now()}`
                }))
            }

            // 病人档案文件列表
            if (this.formData.patientFile) {
                this.patientFileList = this.formData.patientFile.split(',').map((url, index) => ({
                    name: `病人档案_${index + 1}`,
                    url: this.getFileDisplayUrl(`file_${index}.pdf`, url),
                    uid: `patientFile_${index}_${Date.now()}`
                }))
            }
        },

        // ========== 文件上传相关方法 ==========

        // 自定义上传方法
        async customUpload(options, fieldType) {
            const { file, onProgress, onSuccess, onError } = options;

            const formData = new FormData();
            formData.append('file', file);

            try {
                // 使用项目中定义的uploadFile API
                const response = await this.$http.uploadFile(formData);

                console.log('上传响应:', response);

                if (response.status === 200) {
                    // 上传成功，添加到对应的文件列表
                    response.result.forEach((item) => {
                        this.addFileToList(fieldType, file, item.fileUrl);
                    });

                    onSuccess(response);
                } else {
                    // 上传失败，显示错误消息
                    this.$message({
                        type: 'error',
                        message: response.message || '文件上传失败'
                    });
                    onError(new Error(response.message || '文件上传失败'));
                }
            } catch (error) {
                console.error('上传错误:', error);
                this.$message({
                    type: 'error',
                    message: '文件上传失败: ' + (error.message || '网络错误')
                });
                onError(error);
            }
        },

        // 添加文件到对应列表
        addFileToList(fieldType, file, fileUrl) {
            const displayUrl = this.getFileDisplayUrl(file.name, fileUrl);
            const fileItem = {
                name: file.name,
                url: displayUrl,
                uid: file.uid,
                fileUrl: fileUrl // 保存原始文件URL
            };

            // 根据字段类型添加到对应列表
            switch (fieldType) {
                case 'disinfectionCertificate':
                    this.disinfectionFileList.push(fileItem);
                    this.updateFormDataFromFileList('disinfectionCertificate');
                    break;
                case 'implantationCertificate':
                    this.implantationFileList.push(fileItem);
                    this.updateFormDataFromFileList('implantationCertificate');
                    break;
                case 'patientFile':
                    this.patientFileList.push(fileItem);
                    this.updateFormDataFromFileList('patientFile');
                    break;
            }
        },

        // 更新表单数据中的文件URL字符串
        updateFormDataFromFileList(fieldType) {
            let fileUrls = [];

            switch (fieldType) {
                case 'disinfectionCertificate':
                    fileUrls = this.disinfectionFileList.map(item => item.fileUrl || item.url);
                    this.formData.disinfectionCertificate = fileUrls.join(',');
                    break;
                case 'implantationCertificate':
                    fileUrls = this.implantationFileList.map(item => item.fileUrl || item.url);
                    this.formData.implantationCertificate = fileUrls.join(',');
                    break;
                case 'patientFile':
                    fileUrls = this.patientFileList.map(item => item.fileUrl || item.url);
                    this.formData.patientFile = fileUrls.join(',');
                    break;
            }
        },

        // 获取文件显示URL，PDF文件显示图标
        getFileDisplayUrl(fileName, fileUrl) {
            const fileExtension = fileName.split('.').pop().toLowerCase();
            if (fileExtension === 'pdf') {
                // PDF文件显示PDF图标
                return require('@/assets/pdf1.png');
            } else {
                // 其他文件显示实际图片
                return this.imgUrl ? `${this.imgUrl}/${fileUrl}` : fileUrl;
            }
        },

        // 上传前检查
        beforeUpload(file) {
            // 可以添加文件大小、类型等检查
            const isValidSize = file.size / 1024 / 1024 < 10; // 限制10MB
            if (!isValidSize) {
                this.$message.error('文件大小不能超过 10MB!');
                return false;
            }
            return true;
        },

        // 移除文件前的处理
        beforeRemove(file, fileList, fieldType) {
            // 从对应的文件列表中移除
            switch (fieldType) {
                case 'disinfectionCertificate':
                    const disinfectionIndex = this.disinfectionFileList.findIndex(item => item.uid === file.uid);
                    if (disinfectionIndex > -1) {
                        this.disinfectionFileList.splice(disinfectionIndex, 1);
                        this.updateFormDataFromFileList('disinfectionCertificate');
                    }
                    break;
                case 'implantationCertificate':
                    const implantationIndex = this.implantationFileList.findIndex(item => item.uid === file.uid);
                    if (implantationIndex > -1) {
                        this.implantationFileList.splice(implantationIndex, 1);
                        this.updateFormDataFromFileList('implantationCertificate');
                    }
                    break;
                case 'patientFile':
                    const patientIndex = this.patientFileList.findIndex(item => item.uid === file.uid);
                    if (patientIndex > -1) {
                        this.patientFileList.splice(patientIndex, 1);
                        this.updateFormDataFromFileList('patientFile');
                    }
                    break;
            }
            return true;
        },

        // 初始化图片URL
        initImgUrl() {
            this.imgUrl = this.$store.getters.getConfig?.imgUrl || '';
        },



        // 确认提交
        async handleConfirm() {
            this.$http.pwoapplyregistPwoapplyPC(this.formData).then(res => {
                if (res.status == 200) {
                    this.$message.success('登记成功')
                    this.handleClose()
                } else {
                    this.$message.error(res.message)
                }
            })

        },

        // 取消操作
        handleCancel() {
            this.handleClose()
        },

        // 关闭弹窗
        handleClose() {
            this.dialogVisible = false
            this.$emit('close')
        }
    },

    // 生命周期
    created() {
        this.initImgUrl();
    }
}
</script>

<style scoped>
.dialog-footer {
    text-align: center;
}

.el-form-item {
    margin-bottom: 18px;
}

/* 文件上传样式 */
::v-deep .upload-demo ul {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
}

::v-deep .upload-demo img {
    width: 30px;
    height: 30px;
    margin-left: 0px;
}

::v-deep .upload-demo .el-upload-list--picture .el-upload-list__item {
    width: 70px;
    height: 42px;
    padding: 5px 0px;
    margin-right: 8px;
}

/* PDF图标样式优化 */
::v-deep
    .upload-demo
    .el-upload-list--picture
    .el-upload-list__item
    img[src*="pdf1.png"] {
    object-fit: contain;
    background-color: #f5f5f5;
    border-radius: 4px;
}

/* 上传按钮样式 */
::v-deep .upload-demo .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .upload-demo .el-upload:hover {
    border-color: #409eff;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .el-col {
        margin-bottom: 10px;
    }
}
</style>
